export const formatValue = (metric, hotel, currency_symbol = "€") => {
    const nonDecimalsMetrics = ['clicks_kpi']
    if (["cost_kpi", "generated_kpi", "cpc_kpi","cost_kpi_compare", "generated_kpi_compare", "cpc_kpi_compare"].includes(metric)) {
        return `${currency_symbol}${
            parseFloat(hotel[metric]).toFixed(2) || 0
        }`;
    }
    return !nonDecimalsMetrics.includes(metric) ? parseFloat(hotel[metric]).toFixed(2): hotel[metric] || 0;
};